var _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgDiscsPurple = function SvgDiscsPurple(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 4,
    cy: 12.5,
    rx: 2.5,
    ry: 11,
    fill: "#1D0333"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 9,
    cy: 12.5,
    rx: 4.5,
    ry: 11,
    fill: "#471173"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 15.5,
    cy: 12.5,
    rx: 8,
    ry: 11,
    fill: "#9224ED"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDiscsPurple);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2Ugb3BhY2l0eT0iMC42IiBjeD0iNCIgY3k9IjEyLjUiIHJ4PSIyLjUiIHJ5PSIxMSIgZmlsbD0iIzFEMDMzMyIvPgo8ZWxsaXBzZSBvcGFjaXR5PSIwLjYiIGN4PSI5IiBjeT0iMTIuNSIgcng9IjQuNSIgcnk9IjExIiBmaWxsPSIjNDcxMTczIi8+CjxlbGxpcHNlIG9wYWNpdHk9IjAuNiIgY3g9IjE1LjUiIGN5PSIxMi41IiByeD0iOCIgcnk9IjExIiBmaWxsPSIjOTIyNEVEIi8+Cjwvc3ZnPgo=";